<!--
Author: TangChen
Date: 2018-09-06
Desc: 设置页面底部，为公共组件
 -->
<template>
    <div class="comp-footer comp">
        <div class="container">
            <div v-if="links.length > 0" class="links">
                <a
                    v-for="(link, index) in links"
                    :key="index"
                    target="_black"
                    :href="link.address"
                    :title="link.name"
                    :class="{ last: index === links.length - 1 }"
                >
                    {{ link.name }}
                </a>
            </div>
            <div class="text">
                <div v-if="copyright">
                    {{ copyright }}
                </div>
                <div>
                    <span v-if="$cache.getCompanyInfoParam('10201005')">
                        公司地址: {{ $cache.getCompanyInfoParam("10201005") }}
                    </span>
                    &emsp;
                    <span v-if="recordnum">备案号: {{ recordnum }}</span>
                </div>
                <div>
                    <span v-if="$cache.getCompanyInfoParam('10101009')">
                        客户服务电话: {{ $cache.getCompanyInfoParam("10101009") }}
                    </span>
                    &emsp;&emsp;
                    <span v-if="$cache.getCompanyInfoParam('10101003')">
                        公司办公电话: {{ $cache.getCompanyInfoParam("10101003") }}
                    </span>
                    &emsp;&emsp;
                    <span v-if="fax">传真: {{ fax }}</span>
                    &emsp;&emsp;
                    <span v-if="$cache.getCompanyInfoParam('10101005')">
                        邮编: {{ $cache.getCompanyInfoParam("10101005") }}
                    </span>
                    &emsp;&emsp;
                    <span v-if="$cache.getCompanyInfoParam('10101004')">
                        公司邮箱: {{ $cache.getCompanyInfoParam("10101004") }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FooterCon",
    data() {
        return {
            links: [],
            copyright: "",
            recordnum: "",
            fax: ""
        };
    },
    mounted() {
        /* 机构理财友情链接 版权信息等 暂不适用 */
        // this.links = JSON.parse(this.$cache.getCompanyInfoParam("10201016") || "[]");
        // this.copyright = "版权信息: " + this.$cache.getCompanyInfoParam("10201010");
        // this.fax = "传真: " + this.$cache.getCompanyInfoParam("10201007");
        // this.recordnum = this.$cache.getCompanyInfoParam('10201010'); //备案号
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-footer {
    min-width: 1200px;
    min-height: 80px;
    overflow: hidden;
    text-align: center;
    padding: 8px 0px;
    color: $text-color3;
    .container {
        font-size: 13px;
    }
    .links {
        line-height: 30px;
        a {
            color: $text-color1;
            &:hover {
                color: $color-b;
            }
        }
        a:after {
            content: "|";
            padding: 0 10px;
        }
        a.last:after {
            content: "";
            padding: 0;
        }
    }
    .text {
        text-align: left;
        position: relative;
        display: inline-block;
        div {
            line-height: 30px;
        }
        a {
            color: $text-color1;
            &:hover {
                color: $color-b;
            }
        }
    }
}
</style>
